function handleCartEvents(event) {
    const data = event?.detail;
    const totalPrice = data?.money;
    if (document.querySelector('.opus-ct-checkout')) {
        document.querySelector('.opus-ct-checkout').remove();
    }
    
    document.querySelector('#opus-checkout-btn').insertAdjacentHTML("beforebegin",
        `<div class="opus-ct-checkout" style="font-family: inherit; margin: 5px 0;">
            <div style="display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 0px;">
                <span>SUBTOTAL</span>
                <span>${totalPrice}</span>
            </div>
            <div style="font-size: 12px; color: #666; text-align: left; width: 100%; margin: 0; padding: 0;">
                Taxes and <a href="https://ruementana.com/policies/shipping-policy" style="text-decoration: underline !important; color: #000; cursor: pointer;">shipping</a> calculated at checkout.
            </div>
        </div>`);
    

}

window.addEventListener('OpusCartChange', handleCartEvents);